/**
 * Image mapping system using ES module imports for production compatibility
 * Maps JSON paths to imported asset URLs that work in both dev and production
 */

// Import all images as ES modules
import logo from '@/assets/images/logo.png';
import heroOrchestra from '@/assets/images/hero-orchestra.jpg';
import harmonyRiverEvent from '@/assets/images/harmony-river-event.png';
import musicMulligans from '@/assets/images/music-mulligans.jpg';
import princessBride from '@/assets/images/princess-bride.png';
import educationBackground from '@/assets/images/education-background.jpg';
import instagram1 from '@/assets/images/instagram-1.jpeg';
import instagram2 from '@/assets/images/instagram-2.jpeg';
import instagram3 from '@/assets/images/instagram-3.jpeg';
import instagram4 from '@/assets/images/instagram-4.jpeg';
import instagram5 from '@/assets/images/instagram-5.jpeg';
import instagram6 from '@/assets/images/instagram-6.jpeg';
import freeFamilyConcert from '@/assets/images/free-family-concert.png';
import partnerNacNea from '@/assets/images/partner-nac-nea.jpg';
import partnerElCord from '@/assets/images/partner-el-cord.png';
import partnerRedfield from '@/assets/images/partner-redfield.png';
import partnerRpet from '@/assets/images/partner-rpet.png';
import subscriberBackground from '@/assets/images/subscriber-background.jpg';
import educationSideImage from '@/assets/images/education-side-image.jpg';
import giveBackground from '@/assets/images/give-background.jpg';

/**
 * Image mapping from JSON paths to imported asset URLs
 * This ensures proper asset handling in both development and production builds
 */
const imageMap: Record<string, string> = {
  // Logo
  '/images/logo.png': logo,
  '/assets/images/logo.png': logo,
  '//images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/565b068b-b8b0-407f-9dde-b46eabbcf7e1/Phil_logo_color-NEW-FINAL.png': logo,
  
  // Hero section
  '/images/hero-orchestra.jpg': heroOrchestra,
  '/assets/images/hero-orchestra.jpg': heroOrchestra,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/a0e89320-410a-408e-a522-6afee4265c6d/032323_renoPhil_01817.jpg': heroOrchestra,
  
  // Event images
  '/images/harmony-river-event.png': harmonyRiverEvent,
  '/assets/images/harmony-river-event.png': harmonyRiverEvent,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/3faff15c-1f49-4ff7-9767-7677b1b210df/Harmony+on+the+River+Square+Assets-1.png': harmonyRiverEvent,
  
  '/images/music-mulligans.jpg': musicMulligans,
  '/assets/images/music-mulligans.jpg': musicMulligans,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1747673095563-PAYX294OFPWT7VLXB5KP/Music%2BMulligans%2B25.jpg': musicMulligans,
  
  '/images/princess-bride.png': princessBride,
  '/assets/images/princess-bride.png': princessBride,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1750265493870-HJ1QFDE7B109MMW6VF6S/Princess+Bride+Cordillera.png': princessBride,
  
  // Education section
  '/images/education-background.jpg': educationBackground,
  '/assets/images/education-background.jpg': educationBackground,
  
  // Instagram images
  '/images/instagram-1.jpeg': instagram1,
  '/images/instagram-2.jpeg': instagram2,
  '/images/instagram-3.jpeg': instagram3,
  '/images/instagram-4.jpeg': instagram4,
  '/images/instagram-5.jpeg': instagram5,
  '/images/instagram-6.jpeg': instagram6,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1755549141609-1SAS1SF5HYOE77T0YHF7/image-asset.jpeg': instagram1,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1753131630466-OG22M51TVZTZ7D4JO0ME/image-asset.jpeg': instagram2,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1752772975326-QMFFI8DPD1PP5XI8FOJP/image-asset.jpeg': instagram3,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1752345205979-U0ULUBMVVDCVEW55WE0I/image-asset.jpeg': instagram4,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1752264253997-IZ3Q3147UFR2PGVAEC47/image-asset.jpeg': instagram5,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1752083072496-V6S8I4EBZ4UU2HDOTXIO/image-asset.jpeg': instagram6,
  
  // Event images
  '/images/free-family-concert.png': freeFamilyConcert,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1742504563048-NX2JLTOP9RBDD4NLIPQW/Home+Means+Nevada.png': freeFamilyConcert,
  
  // Partner logos
  '/images/partner-nac-nea.jpg': partnerNacNea,
  '/images/partner-el-cord.png': partnerElCord,
  '/images/partner-redfield.png': partnerRedfield,
  '/images/partner-rpet.png': partnerRpet,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/ed957bbb-94dd-4aae-a331-af2ecfd64c6c/NAC_NEA_Lockup_Vertical_300dpi-768x652.jpg': partnerNacNea,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1697471361045-1SYHLNZWE4RLQ8CR9DRY/elcord1.png': partnerElCord,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/1697471378548-DJUDST4AE41YE4RVN1HC/Redfield+Logo.png': partnerRedfield,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/0904fdbe-40c7-4715-8673-b165e18c2224/RPET_resized.png': partnerRpet,
  
  // Section-specific images  
  '/images/subscriber-background.jpg': subscriberBackground,
  '/assets/images/subscriber-background.jpg': subscriberBackground,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/275480b5-d88b-4f65-b4ff-2e85ce2be822/RPA_crowd1.jpg': subscriberBackground,
  
  '/images/education-side-image.jpg': educationSideImage,
  '/assets/images/education-side-image.jpg': educationSideImage,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/a4e0ba10-2b4b-4687-9952-726341005bfa/Reno+Phil+School+5_2016+HiRes-28.jpg': educationSideImage,

  // Give section background
  '/images/give-background.jpg': giveBackground,
  '/assets/images/give-background.jpg': giveBackground,
  'https://images.squarespace-cdn.com/content/v1/640a88822000af1f3c926a4a/d94f1099-9e6e-41a8-8d10-05aa79b74dd7/rpo_080717_031.jpg': giveBackground
};

/**
 * Resolves image paths from JSON data to actual imported asset URLs
 * @param imagePath - Path from JSON data (e.g., "/assets/images/logo.png")
 * @returns Resolved asset URL that works in both dev and production
 */
export function resolveImagePath(imagePath: string): string {
  // First try exact match in image map
  if (imageMap[imagePath]) {
    return imageMap[imagePath];
  }

  // Try normalized paths (with and without /assets prefix)
  const normalizedPath = imagePath.startsWith("/assets/")
    ? imagePath
    : `/assets${imagePath.startsWith("/") ? imagePath : "/" + imagePath}`;

  if (imageMap[normalizedPath]) {
    return imageMap[normalizedPath];
  }

  // Try legacy path format
  const legacyPath = imagePath.replace("/assets", "");
  if (imageMap[legacyPath]) {
    return imageMap[legacyPath];
  }

  // Fallback: log warning and return original path
  console.warn(`Image not found in image map: ${imagePath}. Available images:`, Object.keys(imageMap));
  return imagePath;
}

/**
 * Get all available image paths for debugging
 */
export function getAvailableImages(): string[] {
  return Object.keys(imageMap);
}

/**
 * Legacy export for compatibility
 */
export const resolveImageUrl = resolveImagePath;
